export default __webpack_public_path__ + "static/media/about-sec-img.2e692d78.jpg";